import { Injectable } from '@angular/core';

import { setoresStorage } from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {frotasStorage} from "../../../bens/frotas/shared/data.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";

@Injectable()
export class SetorService {

  constructor(
    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,
    
    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(setoresStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(setoresStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(setoresStorage + "-new");
  }

  setSessionStorageFatherModule(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(setoresStorage + '-father', object);
  }

  getSessionStorageFatherModule() {
    var item: string = sessionStorage.getItem(setoresStorage + "-father");
    return JSON.parse(item);
  }

  clearSessionStorageFatherModule() {
    sessionStorage.removeItem(setoresStorage + "-father");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.setor = Response;
        this._frotaService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(setoresStorage);

    if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    }

  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/shared/setor.service.ts
 **/